module.exports = __webpack_public_path__ + "img/27.564feeff.png";